<template>
  <template v-if="entity">
    <a v-if="entity.url" :href="entity.url">{{ entity.name }}</a>
    <span v-else>{{ entity.name }}</span>
    <div v-if="withType" class="tw:text-xs tw:text-zinc-500">{{ entity.type }}</div>
  </template>
  <span v-else class="tw:text-zinc-400">—</span>
</template>

<script setup>
defineProps({
  // { type, name, url } as AiUsageResource sends it, or null when unattributed.
  entity: {
    type: Object,
    default: null,
  },
  withType: {
    type: Boolean,
    default: true,
  },
})
</script>
